import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import { responsiveStyles } from "scmp-app/components/header/features/styles";

import IconPostMagazineFlag from "./icon-post-magazine-flag.svg";

export const StyledLogoLink = styled(BaseLink)`
  ${responsiveStyles}
`;

export const StyledPostMagazineLogoFlag = styled(IconPostMagazineFlag)`
  inline-size: 25.75px;
  block-size: 20px;
`;
